import styled from 'styled-components';

import { Card as InnerCard } from '@xing-com/card';
import { Marker as InnerMarker } from '@xing-com/marker';
import { SkeletonCard as InnerSkeletonCard } from '@xing-com/skeleton';
import {
  scale030,
  scale040,
  spaceXL,
  spaceXS,
  spaceXXL,
} from '@xing-com/tokens';

const horizontalWidth = '100%';
const horizontalHeight = 'auto';
const verticalWidth = '100%';
const verticalMinWidth = '187px';
const verticalHeight = '308px';

export const Card = styled(InnerCard)<{ horizontal?: boolean }>`
  overflow: hidden;
  box-shadow: rgba(189, 189, 189, 0.25) 0px 2px 8px 1px;
  border: 0px;
  width: ${(props) => (props.horizontal ? horizontalWidth : verticalWidth)};
  min-width: ${(props) =>
    props.horizontal ? horizontalWidth : verticalMinWidth};
  height: ${(props) => (props.horizontal ? horizontalHeight : verticalHeight)};
  & > div {
    flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
    gap: ${spaceXL};
  }
`;
export const ProfileContainer = styled.div<{ horizontal?: boolean }>`
  display: flex;
  width: ${(props) => (props.horizontal ? 'auto' : '100%')};
  margin-top: ${(props) => (props.horizontal ? '0' : spaceXXL)};
  justify-content: center;
  align-items: center;
`;

export const MarkerContainer = styled.div<{ horizontal?: boolean }>`
  display: flex;
  gap: ${spaceXS};
  height: 20px;
  justify-content: ${(props) => (props.horizontal ? 'left' : 'center')};
  gap: ${spaceXS};
`;

export const MetaContainer = styled.div<{ horizontal?: boolean }>`
  display: flex;
  overflow: hidden;
  gap: ${scale030};
  flex-direction: column;
`;

export const InfoContainer = styled.div<{ horizontal?: boolean }>`
  overflow: hidden;
  text-align: ${(props) => (props.horizontal ? 'left' : 'center')};
`;

export const Marker = styled(InnerMarker)``;

export const SkeletonCard = styled(InnerSkeletonCard)<{
  horizontal?: boolean;
}>`
  width: ${(props) => (props.horizontal ? horizontalWidth : verticalWidth)};
  min-width: ${(props) =>
    props.horizontal ? horizontalWidth : verticalMinWidth};
  height: ${(props) => (props.horizontal ? horizontalHeight : verticalHeight)};
  display: flex;
  flex-direction: ${(props) => (props.horizontal ? 'row' : 'column')};
  gap: ${spaceXXL};
`;
export const SkeletonProfileContainer = styled.div<{ horizontal?: boolean }>`
  display: flex;
  width: ${(props) => (props.horizontal ? 'auto' : '100%')};
  justify-content: center;
`;
export const SkeletonInfoContainer = styled.div<{ horizontal?: boolean }>`
  display: flex;
  flex-direction: column;
  height: 64px;
  width: 100%;
  gap: ${scale040};
`;
